import React, { Component } from 'react';
import SweetAlert2 from 'react-sweetalert2';

export default class MsgBox extends Component
{
    constructor()
    {
        super();
        this.state = {
            swal: {
                show: false,
                title: '',
                text: ''
            }
        }

    }


    render() 
    {

        var swal = {
                show: this.props.show ?? false,
                title: this.props.title,
                text: this.props.text,
                html: this.props.html,
                icon: this.props.icon,
                showCancelButton: (this.props.cancelButtonText),
                cancelButtonText: this.props.cancelButtonText,
                confirmButtonText: this.props.confirmButtonText
        };


        return (
            <div>   
                <SweetAlert2 {...swal}
                    didClose={() => {
                        if (this.props.cancelEvent)
                        {
                            this.props.cancelEvent();
                        }
                        else
                        {
                            this.props.onMsgBoxCloseRequest();
                        }
                    }}
                    onConfirm={result => {
                        // run when clicked in confirm and promise is resolved...
                        if (this.props.confirmEvent)
                        {
                            this.props.confirmEvent();
                        }
                        else 
                        {
                            this.props.onMsgBoxCloseRequest()
                        }
                    }} 
                />
            </div>
        );
    }
}